<template>
  <VuePagination
    v-model="dataValue"
    class="custom-pagination"
    :class="{
      'no-prev': dataValue === 1,
      'no-next': dataValue === totalRows,
    }"
    :records="totalRows"
    :per-page="perPage"
    :options="{
      chunk: visiblePageButtons,
      chunksNavigation: { center: true, },
      edgeNavigation: totalRows > (visiblePageButtons*perPage),
      texts: {
        count: '',
        first: 1,
        last: Math.ceil(totalRows/perPage),
        prevPage: angleLeft,
        nextPage: angleRight,
      },
    }"
    @paginate="$emit('change', $event)"
  />
</template>

<script>
import { h } from "vue";

import { UilAngleLeft, UilAngleRight } from "@iconscout/vue-unicons";

/**
 * Affiche une pagination sous forme de numéros. Des chevrons sont présents pour naviguer vers les pages précédente et
 * suivante, et il y a également des boutons de première et dernière page selon le nombre de pages.
 * Voir la doc pour le fonctionnement https://github.com/matfish2/vue-pagination-2 (mais voir surtout le code car il
 * manque beaucoup de choses…).
 */
export default {
  name: "Pagination",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    /**
     * Numéro de la page actuelle.
     */
    value: {
      type: Number,
      default: 1,
    },
    /**
     * Nombre total de ligne(s) dans le tableau.
     */
    totalRows: {
      type: Number,
      default: 10,
    },
    /**
     * Nombre maximum de boutons (numéros de page) à afficher.
     */
    visiblePageButtons: {
      type: Number,
      default: 5,
    },
    /**
     * Nombre par page.
     */
    perPage: {
      type: Number,
      default: 20,
    },
    /**
     * Identifiant HTML de l'ancre à atteindre au changement de page.
     */
    anchor: {
      type: String,
      default: "",
    },
  },
  emits: [
    /**
     * Déclenché lors d'un changement de page.
     * @param {Number} value Nouvelle page.
     */
    "change",
  ],
  data() {
    return {
      dataValue: this.value,
    };
  },
  computed: {
    angleLeft() {
      return h(UilAngleLeft, { props: { size: "16" } });
    },
    angleRight() {
      return h(UilAngleRight, { props: { size: "16" } });
    },
  },
};
</script>

<style lang="scss">
@use "../../assets/styles/components/nav/pagination.scss";
</style>
